import { useGetFormFieldQuery } from "api/TenantSlug/FormField/hooks";
import { FormFieldSettingsForm } from "components/Forms/FormFieldSettingsForm/FormFieldSettingsForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FormFieldTypes } from "types/enums";
import { DrawerId } from "types/models.ts";

interface FormFieldSettingsDrawerDrawerProps {
    formFieldId: string;
    type: FormFieldTypes;
    formStructureId: string;
}

export const FormFieldSettingsDrawer = ({ formFieldId, type, formStructureId }: FormFieldSettingsDrawerDrawerProps) => {
    const id = DrawerId.FieldSettings;
    const { t } = usePaldockTranslation("forms.form-field-settings");

    const getFormFieldQuery = useGetFormFieldQuery(formFieldId);

    if (!getFormFieldQuery.data?.formField) {
        return <></>;
    }

    return (
        <Drawer
            drawerId={id}
            title={
                <DrawerTitle
                    mainTitle={t("title", { fieldName: getFormFieldQuery.data.formField.visible_description })}
                />
            }
            searchParamsToClean={[`${id}-type`, `${id}-formFieldId`, `${id}-formStructureId`]}
        >
            <FormFieldSettingsForm type={type} formFieldId={formFieldId} formStructureId={formStructureId} />
        </Drawer>
    );
};
